import { z } from "zod";
import type { ControlListItem, FrameworkDetail } from "./schemas";
import { attentionReasons, isPast, within } from "./attention";

export const workFilterSchema = z.enum(["supporting_failed", "supporting_unavailable", "all", "mine", "unowned", "unchecked", "not_met", "expiring", "exception_lapsed", "reviews"]);
export type WorkFilter = z.infer<typeof workFilterSchema>;
export interface ControlWork {
  control: ControlListItem;
  frameworkId: string;
  frameworkVersion: string;
}

export function controlWork(frameworks: FrameworkDetail[]): ControlWork[] {
  return frameworks.filter((f) => f.selected).flatMap((f) => f.controls
    .filter((c) => attentionReasons(c).length > 0)
    .map((control) => ({ control, frameworkId: f.framework_id, frameworkVersion: f.framework_version })))
    .sort((a, b) => ({ critical: 0, high: 1, medium: 2, low: 3 }[a.control.severity] - { critical: 0, high: 1, medium: 2, low: 3 }[b.control.severity]) || a.control.catalog_id.localeCompare(b.control.catalog_id));
}

export function matchesWork(row: ControlWork, filter: WorkFilter, email: string): boolean {
  const c = row.control;
  switch (filter) {
    case "reviews": return false;
    case "supporting_failed": return attentionReasons(c).includes("supporting_failed");
    case "supporting_unavailable": return attentionReasons(c).includes("supporting_unavailable");
    case "mine": return email !== "" && [c.owner_name, c.reviewer_name].some((name) => name.toLowerCase() === email.toLowerCase());
    case "unowned": return c.owner_name === "";
    case "unchecked": return attentionReasons(c).includes("unchecked");
    case "not_met": return attentionReasons(c).some((reason) => reason === "not_met" || reason === "partly_met");
    case "exception_lapsed": return c.treatment === "exception" && isPast(c.exception_expires_at);
    case "expiring": return c.treatment === "exception" && within(c.exception_expires_at);
    default: return true;
  }
}
